import { Button as MuiButton } from '@mui/material';
import Icon from '../../IconSvg/Icon';
import { LelyButtonBaseProps } from '../buttonTypes';

export type LelyButtonProps = LelyButtonBaseProps;

function LelyButton({
  inverted,
  dense,
  fullWidth,
  round,
  square,
  icon,
  leadingIcon,
  trailingIcon,
  startIcon,
  endIcon,
  'data-testid': dataTestId,
  children,
  ...props
}: LelyButtonProps) {
  const iconOnly = round || square;
  const iconOnlyName = icon ?? leadingIcon ?? trailingIcon;
  const leadingIconElement =
    !iconOnly && !startIcon && leadingIcon ? (
      <Icon name={leadingIcon} aria-hidden />
    ) : null;
  const trailingIconElement =
    !iconOnly && !endIcon && trailingIcon ? (
      <Icon name={trailingIcon} aria-hidden />
    ) : null;

  return (
    <MuiButton
      {...props}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      data-inverted={inverted || undefined}
      data-dense={dense || undefined}
      data-full-width={fullWidth || undefined}
      data-icon-only={round || undefined}
      data-square-icon-only={!round && square ? true : undefined}
      data-testid={dataTestId}
    >
      {iconOnly && iconOnlyName ? (
        <Icon name={iconOnlyName} />
      ) : (
        <>
          {leadingIconElement}
          {children}
          {trailingIconElement}
        </>
      )}
    </MuiButton>
  );
}

export default LelyButton;
